import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const strCastUiNodeSpec: UiNodeSpec<'strCast'> = {
    requiredSockets: 'all',
    cfg: () => ({ controlValues: {}, id: getUID(), kind: 'strCast', disabled: false }),
    controls: () => ({}),
    inputs: () => ({ input: { socket: 'anyData', label: 'Input' } }),
    kindLabel: 'String Value Cast',
    nodeCategory: 'text',
    outputs: () => ({ output: { socket: 'string', label: 'Output' } }),
    validator: () => true,
};
